import { rest } from 'msw';
import { baseURL } from '../../__mocks__/utils';
import { profileEndpoint } from './profile';

export const profileHandler = [
  rest.get(baseURL(profileEndpoint), (req, res, ctx) =>
    res(ctx.delay(), ctx.status(403))
  ),
];
